import * as React from 'react';
import System from 'src/helper/system';

const CreateProject = (props) => {

    return (
        <>
            <button className="btn btn-secondary bs5" data-toggle="modal" data-target="#Create-project"
                onClick={async () => {

                    System.popup('BomCreateProjectPopup', { props_afterBOMCreation: props.afterBOMCreation })
                }}><i aria-hidden="true" className="fa fa-plus"></i> Create a Project
            </button>
        </>
    );
};

export default CreateProject;